import { Pipe, PipeTransform } from '@angular/core';
import { CourseSchedule } from '../../../shared-components/student/course-schedule.model';

@Pipe({
  name: 'traditionalGradesFilter'
})
export class TraditionalGradesFilterPipe implements PipeTransform {

  transform(course: CourseSchedule, gradingTerm: string): any {
    return course.ReportCardGradesTerms.filter(o => o.GradingTerm == gradingTerm);
  }
}
